(function () {
    'use strict';

    var MaterialListControl = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/components/material-list.html',
        controllerAs: 'vm',
        bindings: {
            onAdd: '&'
        },
        controller: ['$scope', 'ThemeClassify', 'Material', '$stateParams','$translate',
            function ($scope, ThemeClassify, Material, $stateParams, $translate) {
                var vm = this;
                vm.maskType='recommend';
                vm.storeId = $stateParams.storeId;
                vm.generalMask=[{
                    cancelled: false,
                    id: 646,
                    resource:{
                        identifier: localStorage.getItem('editor-domain') + "clipArt-d1a8bc1c-53f0-4aa5-cb2b-33ea628866f9",
                    },
                    identifier: localStorage.getItem('editor-domain') + "clipArt-d1a8bc1c-53f0-4aa5-cb2b-33ea628866f9",
                    name: $translate.instant("nav.mask.content.圆形蒙版"),
                    opened: true,
                    provider: "qiniu",
                    themeClassifyId: '',
                    themeClassifyName: "",
                    type: "masking",
                    type1:'round'
                },{
                    cancelled: false,
                    id: 646,
                    resource:{
                        identifier: localStorage.getItem('editor-domain') + "material-9c6fd5de-f1b0-48c5-996e-2eb5758f19cc",
                    },
                    identifier: localStorage.getItem('editor-domain') + "material-9c6fd5de-f1b0-48c5-996e-2eb5758f19cc",
                    name: $translate.instant("nav.mask.content.方形蒙版"),
                    opened: true,
                    provider: "qiniu",
                    themeClassifyId: '',
                    themeClassifyName: "",
                    type: "masking",
                    type1: "square",
                }]
                vm.$onInit = function() {
                    classifyInit();
                }
                //分类
                function classifyInit(){
                    ThemeClassify.getAllByCondition4({
                        type: 'Material',
                        storeId: vm.storeId
                    }, function (res) {
                        vm.masklabels = res.data;
                        vm.rahmenPage = 0;
                        vm.maskList = [];
                        rahmenInit(vm.masklabels[0])
                    });
                }


                vm.rahmenPage = 0;
                vm.masklabelsFulfill = false;
                $scope.showMaskLabels = false;
                vm.maskLoading = false;
                vm.masklabelCb = masklabelCb;
                vm.maskList = [];
                $scope.showMoreMaskLabels = function () {
                    $scope.showMaskLabels = !$scope.showMaskLabels;
                }
                function rahmenInit(item) {
                    vm.maskLoading = true;
                    vm.masklabelChooseId = item;
                    Material.byCondition3({
                        items: [
                            {key: "themeClassify.id", op: "=", value: item.id}],
                        page: vm.rahmenPage,
                        size: vm.itemsPerPage
                    }, function (res, headers) {
                        var _sum = headers('X-Total-Count');
                        angular.forEach(res.data, function (resp) {
                            var arr = {
                                type:'masking',
                                name: resp.name,
                                identifier: localStorage.getItem('editor-domain') + resp.identifier,
                                provider: resp.provider,
                                themeClassifyName: resp.themeClassifyName,
                                themeClassifyId: resp.themeClassifyId,
                                resource: {
                                    identifier: localStorage.getItem('editor-domain') + resp.identifier,
                                    provider: resp.provider,
                                }
                            }
                            vm.maskList.push(arr);
                        })
                        vm.maskLoading = false;
                        if(vm.maskList.length < _sum){
                            vm.masklabelsFulfill = true;
                        }else {
                            vm.masklabelsFulfill = false;
                        }
                    }, function () {
                        vm.maskLoading = false;
                    })
                }
                function masklabelCb(item){
                    vm.maskList = [];
                    vm.rahmenPage = 0;
                    rahmenInit(item)
                }
                $scope.loadMoreMasks = function () {
                    vm.rahmenPage++;
                    rahmenInit(vm.masklabelChooseId)
                }
            }]
    };

    angular.module('editorApp')
        .component('materialList', MaterialListControl);

})();
